export const EngagementLetterActions = {
  setEditEngagementLetterDialog: async ({ commit }, value) => commit('setEditEngagementLetterDialog', value),
}

export const EngagementLetterGetters = {
  editEngagementLetterDialog: state => state.editEngagementLetterDialog,
}

export const EngagementLetterMutations = {
  setEditEngagementLetterDialog: (state, value) => { state.editEngagementLetterDialog = value },
}

export const EngagementLetterState = {
  editEngagementLetterDialog: false,
}
